<template>
  <scouter-list scouter-type="participant" />
</template>

<script>
import ScouterList from '@/components/scouters/scouter-list.vue'

export default {
  name: 'ParticipantList',
  components: {
    ScouterList
  }
}
</script>
